import { organizationsPath } from '../../utilities/api_relative_paths';
import { checkStatus } from '../../utilities/fetch';
import { createQueryString } from '../../utilities/utilities';

/**
 * GET: request to list the contacts of an organization
 *
 * @param {string} organizationId - the organization to search for
 * @param {('former'|'current'|'official')} [type] - includes all types if left blank
 * @param {number} [pageSize] - maximum number of results to return. defaults to 10
 * @param {number} [pageNumber] - index to start returning results from. defaults to 1
 * @returns {Promise} Promise that can be extended
 */
export const getOrganizationContacts = (organizationId, type, pageSize, pageNumber) =>
  fetch(
    `${organizationsPath}/${organizationId}/contacts${createQueryString({
      type,
      'page[size]': pageSize,
      'page[number]': pageNumber,
    })}`
  )
    .then(checkStatus)
    .then((response) => response.json());

/**
 * DELETE: remove a contact from the contacts of the organization
 *
 * @param {string} organizationId - the organization to search for
 * @param {string} contactId - the Id of the contact to be removed
 * @returns {Promise} Promise that can be extended
 */
export const removeContactFromOrganization = (organizationId, contactId) =>
  fetch(`${organizationsPath}/${organizationId}/contacts/${contactId}`, { method: 'delete' })
    .then(checkStatus)
    .then((response) => response.json());

/**
 * PATCH: modify a contact of an organization
 *
 * @param {string} organizationId - the organization to search for
 * @param {object} fields - new data for the contact
 * @param {string} contactId - the Id of the contact to be removed
 * @returns {Promise} Promise that can be extended
 */
export const modifyUserInOrganization = (organizationId, fields, contactId) =>
  fetch(`${organizationsPath}/${organizationId}/contacts/${contactId}`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(checkStatus)
    .then((response) => response.json());

/**
 * POST: add a contact to an organization
 *
 * @param {string} organizationId - the organization to search for
 * @param {object} fields - new data for the contact
 * @returns {Promise} Promise that can be extended
 */
export const addUserToOrganization = (organizationId, fields) =>
  fetch(`${organizationsPath}/${organizationId}/contacts`, {
    method: 'POST',
    body: JSON.stringify(fields),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(checkStatus)
    .then((response) => response.json());
